<template>
  <div class="app-layout d-flex flex-column">
    <div id="content" class="container-fluid col h-100">
      <div class="row h-100">
        <div class="col mw-25">
          <vue-perfect-scrollbar>
            <div class="p-4 min-vh-80">
              <o-child/>
            </div>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#content {
  padding-top: 0px;
}
</style>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'standalone-layout',
  components: {
    VuePerfectScrollbar
  }
}
</script>
